export const createTimeTrackingFormDefaultValues = {
	hours: 0,
	locationName: "",
	minutes: 0,
	text: "",
	isBillable: false,
	bookOnQuota: false,
};